/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber5 = createReactComponent("number-5", "IconNumber5", [
  ["path", { d: "M8 20h4a4 4 0 1 0 0 -8h-4v-8h8", key: "svg-0" }]
]);

export { IconNumber5 as default };
//# sourceMappingURL=IconNumber5.js.map
